<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <div class="profile-nota-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span>
                        
                        <div class="row g-4">
                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="notaMin" class="form-label">Nota Minima</label>
                                <input id="notaMin" v-model="notaMin" @keyup="apertouEnter" type="text" class="form-control form-control-solid" placeholder="Nota minima"/>
                            </div>
                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="notaMax" class="form-label">Nota Maxima</label>
                                <input
                                    id="notaMax"
                                    v-model="notaMax"
                                    @keyup="apertouEnter"
                                    type="text"
                                    class="form-control form-control-solid"
                                    placeholder="Nota maxima"
                                />
                            </div>
                        </div>
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false" @tableatualizada="tableatualizada( $event )">
                            <th>Disciplina</th>
                            <th>Tipo</th>
                            <th>Nota</th>
                            <th>Status</th>
                            <th class="text-center" style="min-width:350px">Acoes</th>
                        </KDataTable>
                    </section>
                </div>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    import CardRh from "@/components/cards/ManzaCard.vue";
    import NotaService from "@/service/v10/sigap/NotaService";
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import SiteUtils from '@/assets/ts/aplicacao/site';
    import $ from "jquery";

    @Options({
        name: "NotasIndex",
        components: { CardRh, KDataTable },
    })
    export default class NotasIndex extends Vue {
        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = null;
        public matriculaId: any = null;
        public notaMin = '';
        public notaMax = '';

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                this.refreshTable();
            }
        }
 

        created() {
            this.matriculaId = this.$route.params.id;
            this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
            this.service = new NotaService();
            this.config.ajax = {
                url: this.service.getApiUrl(),
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        matriculaId: this.matriculaId,
                        notaMax: this.notaMax,
                        notaMin: this.notaMin,
                        search: d.search.value,
                    };
                    return dados;
                }
            };

            this.config.columns = [
                { data: 'disciplina.descricao', name: 'disciplina' },
                { data: 'tipo', name: 'tipo' },
                { data: 'notaValor', name: 'notavalor' },
                { data: 'status', name: 'status ' },
                { data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center all' }
            ];

            this.config.columnDefs = [
                {
                    targets: 1,
                    render: (row) => {
                        return row.nome.replaceAll('_', ' ');
                    }
                },
                {
                    targets: 3,
                    render: (row) => {
                        return row.nome.replaceAll('_', ' ');
                    }
                },
                {
                    targets: 4,
                    render: (row, type, val) => {
                        let texto = '';
                        if (val.status.id == 2) {
                            const buttom = ' data-id="' + val.id + '"';
                            texto = texto + '<button class="btn btn-warning btn-sm" btn-revisao ' + buttom + '><i class="fa-solid fa-magnifying-glass"></i>Solicitar revisao</button>';
                            texto = texto + '<button class="btn btn-success btn-sm" btn-homologar ' + buttom + '><i class="fa fa-medal"></i>Homologar</button>';
                        }
                        return texto;
                    },
                }
            ];
        }

        public tableatualizada() {
            $('[btn-revisao]').click((btn) => {
                const nota_id = $(btn.currentTarget).data('id');
                this.solicitarRevisao(nota_id);
            });
            $('[btn-homologar]').click((btn) => {
                const nota_id = $(btn.currentTarget).data('id');
                this.homologarNota(nota_id);
            });
        }

        protected solicitarRevisao(id) {
            SiteUtils.alertConfimacao('Deseja solicitar a revisao da nota? ', '',
                () => {
                    this.processando = true;
                    setTimeout(() => {
                        this.service.solicitarRevisaoProfile(id)
                            .then(() => {
                                this.reloadDatatable = !this.reloadDatatable;
                                SiteUtils.alertNotificacao('ATENCAO!', 'Sua nota foi devolvida para analise! Crie um CHAMADO explicando o motivo da solicitacao de revisao!');
                                this.processando = false;
                            })
                            .catch(error => {
                                this.processando = false;
                                SiteUtils.toastErro('Nao foi possivel solicitar Revisao', error.data.message);
                            });
                    }, 10);
                }
            );
        }

        protected homologarNota(id) {
            SiteUtils.alertConfimacao('Deseja dar o ciente a nota? ', '(Apos esta acao a nota sera arquivada)',
                () => {
                    this.processando = true;
                    setTimeout(() => {
                        this.service.homologarNotaProfile(id)
                            .then(() => {
                                this.reloadDatatable = !this.reloadDatatable;
                                SiteUtils.toastSucesso('Ciente cadastrado com successo.');
                                this.processando = false;
                            })
                            .catch(error => {
                                this.processando = false;
                                SiteUtils.toastErro('Nao foi possivel dar o ciente na Nota', error.data.message);
                            });
                    }, 10);
                }
            );
        }
    }
</script>

<style scoped>
    .profile-nota-page {
        display: grid;
        gap: 24px;
    }

    .filter-panel,
    .table-panel {
        border: 1px solid #e5edf6;
        border-radius: 22px;
        background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
        padding: 15px;
    }

    .filter-panel {
        position: relative;
        padding-top: 24px;
    }

    .panel-border-label {
        position: absolute;
        top: -9px;
        left: 18px;
        padding: 0 10px;
        background: #ffffff;
        color: #102542;
        font-size: 0.95rem;
        font-weight: 800;
        line-height: 1.4;
    }

    .table-panel {
        padding: 2px 10px !important;
    }

    .panel-heading {
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        gap: 10px;
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e9eef5;
    }

    .panel-title {
        margin-bottom: 2px;
        color: #102542;
        font-size: 1.05rem;
        font-weight: 800;
    }

    .panel-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }

    .btn-sm {
        margin-left: 10px;
    }

    .panel-actions .btn-sm {
        margin-left: 0;
    }

    .registro-alteracao {
        text-align: right;
    }

    @media screen and (max-width: 991px) {
        .filter-panel,
        .table-panel {
            padding: 18px;
            border-radius: 18px;
        }

        .filter-panel {
            padding-top: 26px;
        }

        .panel-heading {
            flex-direction: column;
            align-items: stretch;
        }
    }
</style>
